export function SessionProgress({
  currentStatementIndex,
  statementsCount,
}: {
  currentStatementIndex: number;
  statementsCount: number;
}) {
  return (
    <div className="voting-session__progress">
      <span className="voting-session__progress-current">
        {currentStatementIndex + 1}{" "}
      </span>
      / {statementsCount}
    </div>
  );
}
